import { render, staticRenderFns } from "./ModalBarTabClose.vue?vue&type=template&id=b90baf64&scoped=true&"
import script from "./ModalBarTabClose.vue?vue&type=script&lang=js&"
export * from "./ModalBarTabClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90baf64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b90baf64')) {
      api.createRecord('b90baf64', component.options)
    } else {
      api.reload('b90baf64', component.options)
    }
    module.hot.accept("./ModalBarTabClose.vue?vue&type=template&id=b90baf64&scoped=true&", function () {
      api.rerender('b90baf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/components/modals/ModalBarTabClose.vue"
export default component.exports